import { forwardRef } from "react";
import { Form, Settings, SettingsItem, Select, TextField } from "ui";
import { MenuItem } from "@mui/material";
import ElavonModel from "./types/ElavonModel";
import FormRef from "../types/FormRef";

type ElavonFormProps = {
    errors: any;
    loading: boolean;
    onSubmit: (data: ElavonModel) => void;
};

const ElavonForm = forwardRef<FormRef, ElavonFormProps>(
    ({ errors, loading, onSubmit }, ref) => {
        return (
            <Form
                ref={ref}
                data={{}}
                errors={errors}
                fields={{
                    public_key: {},
                    secret_key: {},
                    merchant_alias: {},
                    processor_id: {},
                    environment: { default: "production" },
                }}
                loading={loading}
                onSubmit={onSubmit}
                preventLeftForm
                unsaved={false}
            >
                {(context: any) => {
                    return (
                        <>
                            <Settings>
                                <SettingsItem label="Environment">
                                    <Select
                                        fullWidth
                                        id="environment"
                                        margin="none"
                                    >
                                        <MenuItem value="test">Test</MenuItem>
                                        <MenuItem value="production">
                                            Production
                                        </MenuItem>
                                    </Select>
                                </SettingsItem>
                                <SettingsItem label="Public Key">
                                    <TextField
                                        fullWidth
                                        id="public_key"
                                        margin="none"
                                    />
                                </SettingsItem>
                                <SettingsItem label="Secret Key">
                                    <TextField
                                        fullWidth
                                        id="secret_key"
                                        margin="none"
                                    />
                                </SettingsItem>
                                <SettingsItem label="Merchant Alias">
                                    <TextField
                                        fullWidth
                                        id="merchant_alias"
                                        margin="none"
                                    />
                                </SettingsItem>
                                <SettingsItem label="Processor ID">
                                    <TextField
                                        fullWidth
                                        id="processor_id"
                                        margin="none"
                                    />
                                </SettingsItem>
                            </Settings>
                        </>
                    );
                }}
            </Form>
        );
    },
);

export default ElavonForm;
